module.exports = __webpack_public_path__ + "static/media/chigni.6d28f526.jpg";